import { React, useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  overlay: {
    position: "absolute",
    inset: 0,
    backdropFilter: "blur(6px)",
    background: "rgba(255,255,255,0.7)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
  },
  progressWrapper: {
    position: "relative",
    display: "inline-flex",
  },
  progressText: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 600,
    color: "#f37f46",
  },
  loadingText: {
    marginTop: 16,
    fontWeight: 500,
    color: "#444",
    letterSpacing: "0.5px",
  },
  subText: {
    fontSize: "12px",
    color: "#888",
    marginTop: 4,
  },
}));

const CustomLoadingOverlay = () => {
  const classes = useStyles();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let value = 0;

    const timer = setInterval(() => {
      value += 2;
      if (value > 100) value = 0;
      setProgress(value);
    }, 50);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className={classes.overlay}>
      <Box className={classes.progressWrapper}>
        <CircularProgress
          variant="determinate"
          value={progress}
          size={80}
          thickness={5}
          style={{ color: "#f37f46" }}
        />
        <Box className={classes.progressText}>
          <Typography variant="body2">{`${progress}%`}</Typography>
        </Box>
      </Box>
      <Typography className={classes.loadingText}>
        Loading data...
      </Typography>
      <Typography className={classes.subText}>
        Please wait while we fetch results
      </Typography>
    </div>
  );
};

export default CustomLoadingOverlay;